import { traningTrackingRecord } from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllTrainigRecords = (
  schoolData: string[],
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  const schoolsQuery = schoolData
    ?.map((school) => `schools[]=${encodeURIComponent(school)}`)
    .join('&')
  return get(
    `${BASE_URL}/training-records/track-record?sortBy=${sortBy}&sortOrder=${sortOrderValue}&${schoolsQuery}`
  )
}

export const getAllSafeguardingRecordsCategories = (
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/safeguarding-record-categories?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const createSafeguardingCategory = (data: {
  riskAssessment: boolean
  expiryDate: boolean
  issueDate: boolean
  title: string
  referenceUrl: string
}): Promise<unknown> => {
  return post(`${BASE_URL}/safeguarding-record-categories`, data, null)
}

export const updateSafeguardingRecordCategory = (
  data: {
    riskAssessment: boolean
    expiryDate: boolean
    issueDate: boolean
    title: string
    referenceUrl: string
  },
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/safeguarding-record-categories/${id}`, data, null)
}

export const deleteCategory = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/safeguarding-record-categories/${id}`, null)
}

export const updateTraningRecord = (
  data: traningTrackingRecord,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/training-records/track-record/${id}`, data, null)
}

export const deleteTraningRecord = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/training-records/track-record/${id}`, null)
}

export const getTraningRecordById = (
  id: string,
  schoolId: string | undefined
): Promise<unknown> => {
  return get(
    `${BASE_URL}/training-records/track-record/${id}?school=${schoolId}`
  )
}
